import tip0 from '../images/tips/tip0.svg';
import tip1 from '../images/tips/tip1.svg';
import tip2 from '../images/tips/tip2.svg';
import tip3 from '../images/tips/tip3.svg';
import tip4 from '../images/tips/tip4.svg';
import tip5 from '../images/tips/tip5.svg';
import tip6 from '../images/tips/tip6.svg';
import tip8 from '../images/tips/tip8.svg';
import tip9 from '../images/tips/tip9.svg';
import tip10 from '../images/tips/tip10.svg';
import tip11 from '../images/tips/tip11.svg';
import tip12 from '../images/tips/tip12.svg';
import tip13 from '../images/tips/tip13.svg';
import tip14 from '../images/tips/tip14.svg';

const tips = [
  {
    tip:
      'The air conditioner is the electronic that uses the most power at home. Try using a programmable thermostat. That way when you aren’t home you can let the temperature rise slightly, and when you arrive it can adjust to more comfortable temperatures.      ',
    img: tip0,
  },
  {
    tip:
      'About 80% of our trash ends up in landfills which produces methane as it decomposes. Recycling and reusing items like water bottles and clothing can help drastically reduce your greenhouse gas emissions.',
      img: tip2,

  },
  {
    tip: "When in constant use, electronic devices account for up to 60% of an average American home electric consumption. A great way to reduce this is by going outside to play with your friends, turning off electronics at home, and turning off the air conditioner.",
    img: tip0,

  },
  {
    tip:'The Department of Energy states that the cost to light your home is about 20% of your total electric bill. A great way to reduce your carbon footprint at home is by updating to newer LED bulbs and always making sure you turn off the lights when you leave a room.',
    img: tip3,
  },
  {
    tip: 'It is expected that by 2030, 3 out of 4 light bulbs will be using LED technology. Now is a great time to switch yours.'
    ,img: tip11,
  },
  {
    tip: "About 80% of our trash ends up in landfills which produces methane as it decomposes. Recycling and reusing items like water bottles and clothing can help drastically reduce your greenhouse gas emissions."
    ,img: tip1,
  },
  {
    tip: 'E-Waste accounts for roughly 70% of all toxic waste and contains many toxic materials, including mercury, lead, arsenic, and cadmium. The best way to get rid of old devices is by trading them in at electronic recycling centers.',
    img: tip1,
  },
  {
    tip: "Recycling correctly helps reduce contamination in our recycling, which reduces pollution and can help improve the overall health of our communities.   ",
    img: tip1,
  },
  {
    tip: "You can recycle plastic bags by taking them to local grocery stores, but placing them in your recycling bins causes the recycling facilities to shut down in order to use blow torches and other tools to get plastic bags out of their sorting machinery. ",
    img: tip12,
  },
  {
    tip: "Shortening your shower time by three minutes can reduce the amount of water you use per shower by up to ten gallons. Aim for a five minute shower, planet earth will thank you.",
    img: tip4
  },
  {
    tip:"Conserving water helps conserve energy and reduce carbon pollution. Just by turning off the tap while you brush your teeth in the morning and before bedtime, you can save up to 8 gallons of water!",
    img: tip13,
  },
  {
    tip: "Watering your lawn earlier or later in the day helps reduce how much water you need for your yard to look green and healthy! The sun evaporates most of the water when it is hot outside."
  },
  {
    tip: 'Using a bucket can be an easy and quick way to clean your car and save water while doing so.',
    img: tip12,
  },
  {
    tip:
      'Using low flow shower heads can help reduce your shower water usage by 60% each month!',
      img: tip1,
  },
  {
    tip:
      'Using low flow shower heads can help reduce your shower water usage by 60% each month!',
      img: tip1,
  },
  {
    tip: "Though walking and biking are the most eco-friendly ways of commuting, sharing rides means that everyone involved drives less, thus lowering everyone's carbon footprint. Cars are responsible for producing large amounts of carbon dioxide, the heat-trapping gas that causes global warming.",
    img: tip5
  },
  
{
  tip: 'The global aviation industry produces around 2% of all human-induced carbon dioxide emissions. Mile for mile, flying is the most damaging way to travel for the climate.',
img: tip8,
},
{
  tip: 'Reducing your commute is a great way to reduce your overall environmental impact on the planet!'
  ,img: tip1,
},
{
  tip: 'Public transportation such as metro rails, trains, and busses can not only help you reduce your carbon footprint, but also reduce wear and tear from your vehicle.' 
  ,img: tip1,
},
{
  tip: 'New apparel production releases tons of harmful carbon emissions annually, contributing more than 8% of global greenhouse emissions. The single best thing we can do for the planet is consume less and reuse more.',
  img: tip6
},
{
  tip:
  'Buying foods from local vendors benefits the environment and the local farming community. Locally sourced foods that are in season generally have fewer pesticides and herbicides, which are toxic to surrounding organisms and can contaminate soil and vegetation.',
  img: tip9

},

{
  tip: 'Thrifting is a great way to help the environment it helps reduce the amount of clothing that ends up in landfills.',
  img: tip14,
},
{
  tip: 
  'Buying foods from local vendors benefits the environment and the local farming community. Locally sourced foods that are in season generally have fewer pesticides and herbicides, which are toxic to surrounding organisms and can contaminate soil and vegetation.',
  img: tip10,

},

{
  tip:
  "Saving your leftovers for later is a great way to reduce your waste. An alternative is composting your leftovers which can be used to enrich your plants soil later!"
  ,img: tip10,
},

{
  tip: "Bringing your own shopping bag is the best way to avoid plastic bags! "
  ,img: tip1,
}



];

export default tips;
